<template>
  <div>
    <div v-if="loader">
      <div class="spinner"></div>
    </div>

    <!--   Main Content Start Here   -->
    <main>
      <section class="dashboard_wraper">
        <div class="container_large">
          <div class="row">
            <!-- starting side bar -->
            <sidebar-component></sidebar-component>
            <!-- ending sidebar  -->
            <div class="col-md-12 col-lg-9">
              <div class="dashboard_card">
              <div class="row" v-if="$route.params.order_created_success">
               <span class="alert alert-primary">Your Order Was Created Successfully! </span>
               <h3 style="font-size:1.75rem; padding-bottom:20px">Please check your email for order details.  </h3>
               
               </div>
                <div class="row">
                  <div class="col-6">
                    <h2>Orders</h2>
                  </div>
                  <div class="col-6 text-right">
                    <router-link :to="{name:'order'}">
                    <button
                      type="button"
                      class="button primary_button"
                      aria-label="Close"
                    >
                      Add new order
                    </button>
                    </router-link>
                  </div>
                </div>

                <div class="table-responsive">
                  <table class="table">
                    <thead>
                      <tr>
                        <th scope="col">ID</th>
                        <th scope="col">Date</th>
                        <th scope="col">Name</th>
                        <th scope="col">Amount</th>
                        <th scope="col">Status</th>
                        <th scope="col">Actions</th>
                      </tr>
                    </thead>
                    <tbody v-if="orders && orders.length">
                      <!-- Leave First Row Empty -->
                      <tr>
                        <td colspan="6"></td>
                      </tr>

                      <!-- Loop Start Here -->
                      <tr v-for="data in orders" :key="data">
                        <td>{{ data.id }}</td>
                        <td>{{ data.formated_created }}</td>
                        <td>
                          {{
                            data.order_user && data.order_user.full_name
                              ? data.order_user.full_name
                              : ""
                          }}
                        </td>
                        <td>${{ data.total }}</td>
                        <td>
                          <span
                            class="requested_order"
                            v-if="data.status == '0'"
                            >Cleaning</span
                          >
                          <span
                            class="processed_order"
                            v-if="data.status == '1'"
                            >Cleaned and Ready to Deliver</span
                          >
                          <span
                            class="completed_order"
                            v-if="data.status == '2'"
                            >Completed</span
                          >
                          <span
                            class="processed_order"
                            v-if="data.status == '4'"
                            >Awaiting Pickup</span
                          >
                        </td>
                        <td>
                          <router-link
                            :to="{
                              name: 'order-details',
                              params: { id: data.id,type:'view' },
                            }"
                            class="table_action"
                            ><img src="/src/assets/images/view-icon.svg" alt=""
                          /></router-link>
                           <router-link
                            :to="{
                              name: 'order-details',
                              params: { id: data.id,type:'edit' },
                            }" class="table_action"
                            ><img src="/src/assets/images/edit-icon.svg" alt=""
                          /></router-link>
                          <a
                            href="#"
                            class="table_action"
                            @click="deleteModal(data.id)"
                            ><img src="/src/assets/images/del-icon.svg" alt=""
                          /></a>
                        </td>
                      </tr>
                    </tbody>

                    <tbody v-if="!orders || !orders.length">
                       <!-- Leave First Row Empty -->
                      <tr>
                        <td colspan="6"></td>
                      </tr>

                      <!-- Loop Start Here -->
                      <tr>
                        You don't have created any order yet
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
    <!--   Main Content End Here   -->

    <!-- Delete Modal -->
    <div
      class="modal fade"
      id="delete_order"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body">
            <div class="close_modal">
              <button type="button" data-bs-dismiss="modal" aria-label="Close">
                <i class="fi fi-rr-cross-small"></i>
              </button>
            </div>
            <div class="modal_content">
              <h2>Delete Order</h2>
              <p>Are you sure want to delete this Order?</p>
              <div class="modal_buttons">
                <button
                  type="button"
                  class="button secondary_button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  No
                </button>
                <button
                  type="button"
                  class="button primary_button"
                  @click.prevent="deleteOrder()"
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sidebarComponent from "./sidebar";

import { getCurrentUserId } from "../../utils/auth";
import usersApis from "../../Apis/users";
import moment from "moment";
export default {
  components: {
    sidebarComponent,
  },
  data() {
    return {
      loader: true,
      orders: null,
      deleted_id: null,
    };
  },
  methods: {
    deleteModal(id) {
      this.deleted_id = id;

      var myModal = new bootstrap.Modal(
        document.getElementById("delete_order")
      );
      myModal.show();
    },
    async deleteOrder() {
      console.log("dddd");
      this.loader = true;

      await usersApis.deleteOrder(this.deleted_id);

      this.deleted_id = null;
      this.getOrders();
      var myModal = new bootstrap.Modal(
        document.getElementById("delete_order")
      );
      myModal.hide();

      $("body").removeClass("modal-open");
      $(".fade").removeClass("show");
      $("body").css("padding-right", "0px");
      setTimeout(() => {
        this.loader = false;
      }, 1000);
    },

    async getOrders() {
      let user_id = getCurrentUserId();
      const response = (await usersApis.getUserOrder(user_id)).data;
      if (response && response.length) {
        response.forEach((element) => {
          element.formated_created = moment
            .unix(element.createdDate)
            .format("MM-DD-YYYY");
          return element;
        });
        this.orders = response;
      }
    },
  },

  async created() {
    this.getOrders();
    // moment(nextDate._d).format("DD-MM-YYYY");
    setTimeout(() => {
      this.loader = false;
    }, 1000);
  },
};
</script>



// WEBPACK FOOTER //
// src/components/accounts/my-orders.vue